import { Button } from '@chakra-ui/react'
import { PageAlert } from 'BrokerTsLib/src/components'
import { useGetCurrentOrganizationUnit } from 'brokertslib/src/hooks/useOrganizationUnit'
import { useMemo } from 'react'
import { useNavigate } from 'react-router'

import { HeaderButton } from '@/components'
import { OrganizationHeader } from '@/containers/organization/OrganizationHeader'
import { OrganizationTransferButton } from '@/containers/organization/OrganizationTransferButton'
import { SidebarProvider } from '@/context/SidebarContext'
import { PageWrapper } from '@/layouts/components/PageWrapper'
import { Sidebar } from '@/layouts/components/Sidebar'
import { Breadcrumbs } from 'BrokerTsLib/src/containers/Breadcrumbs'

import { OrganizationDetail } from '../../containers/organization/OrganizationDetail'
import { useAuth } from '../../context/AuthContext'
import { Edit, Refresh } from '../../icons'

export const OrganizationCurrentPage = () => {
  const navigate = useNavigate()
  const { user } = useAuth()
  const { data, refetch, isLoading, isError } = useGetCurrentOrganizationUnit()
  const organization = data?.data

  const breadcrumbs = useMemo(() => {
    const items = []

    if (user?.allowDisplayOrganizationStructure)
      items.push({ to: '/organization/list', label: 'Seznam organizací' })

    if (data?.data.superiorOrganizationUnitId)
      items.push({
        to: `/organization/${data?.data.superiorOrganizationUnitId}`,
        label: data.data.superiorOrganizationUnitName ?? 'Nadřízená organizace',
      })

    items.push({
      to: '/organization',
      label: data?.data.name ?? 'Organizace',
      current: true,
    })

    return items
  }, [user, data])

  return isError ? (
    <PageAlert status="error" title="Chyba při načítání stránky">
      <Button colorScheme="red" isLoading={isLoading} onClick={() => refetch()}>
        <Refresh /> Obnovit stránku
      </Button>
    </PageAlert>
  ) : (
    <SidebarProvider>
      <PageWrapper
        header={
          <>
            <Breadcrumbs items={breadcrumbs} />
            <OrganizationHeader organization={data?.data} isLoading={isLoading}>
              {user?.allowEditOrganizationStructure && (<>
                <OrganizationTransferButton {...data?.data} />
                <HeaderButton
                  onClick={() =>
                    navigate(`/organization/${organization?.id}/edit`)
                  }
                  variant="solid"
                  colorScheme="primary"
                  _hover={{ bg: 'primary.600' }}
                >
                  <Edit />
                  Upravit
                </HeaderButton>
              </>
              )}
            </OrganizationHeader>
          </>
        }
        sidebar={<Sidebar />}
        mainProps={{
          sx: {
            pt: { base: 0, md: 8 },
            gap: 6,
            display: 'grid',
            alignContent: 'baseline',
          },
        }}
      >
        <OrganizationDetail organization={data?.data} isLoading={isLoading} />
      </PageWrapper>
    </SidebarProvider>
  )
}
